export default __webpack_public_path__ + "static/media/logo2.c8a5f08d.png";